/**
 * Veeam Service Provider Console REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface OAuth2ClientSettings { 
    /**
     * Type of OAuth 2.0 identity provider.
     */
    kind: OAuth2ClientSettingsKind;
    /**
     * ID assigned to a client.
     */
    clientId: string;
    /**
     * Client secret.
     */
    clientSecret?: string | null;
    /**
     * Access token scope. > Leave empty to use default scope. 
     */
    scope?: string | null;
    /**
     * Tenant ID for Azure OAuth 2.0 service provider.
     */
    tenantId?: string | null;
}
export enum OAuth2ClientSettingsKind {
    Google = 'Google',
    Azure = 'Azure'
};



